// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  useMediaQuery,
  Typography,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useEffect, useState } from "react";
import useAuth from "hooks/useAuth";
// project imports
import LAYOUT_CONST from "constant";
import useConfig from "hooks/useConfig";
import ProfileSection from "./ProfileSection";
import { useDispatch, useSelector } from "store";
import { openDrawer } from "store/slices/menu";
// assets
import { IconMenu2 } from "@tabler/icons";
import Chip from "./Chip";
import Blink from "react-blink-text";
import CalculatedIndex from "./CalculaterIcon.js";
import Onboarding from "./Onboarding";
import { useNavigate } from "react-router-dom";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();

  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);
  const flag = useSelector((state) => state.flag.value);
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  const { layout } = useConfig();
  const Usersid = window.localStorage.getItem("users");
  const { MemberProfile, Onboarding, researchReportSsoGenerate } = useAuth();
  const val = JSON.parse(Usersid);
  const NId = val.id;
  const CurrentUserId = NId;
  const Space = " ";
  const [city, setcity] = useState([]);
  const [email, setemail] = useState([]);
  const [fname, setfname] = useState([]);
  const [lname, setlname] = useState([]);
  const [profileProgress, setprofileProgress] = useState([]);
  const [onboardingProgress, setOnboardingProgress] = useState(0);
  const [imgurl, setimgurl] = useState([]);
  const userInfoData = async (value) => {
    const list = await MemberProfile(NId, NId);
    setemail(list.data.data.profile_details[0].email);
    setcity(list.data.data.profile_details[0].city);
    setlname(list.data.data.profile_details[0].lname);
    setfname(list.data.data.profile_details[0].fname);
    setimgurl(list.data.data.profile_details[0].imgurl);
    setprofileProgress(list.data.data.profile_details[0].profileProgress);
  };
  const getOnboardingProgress = async () => {
    try {
      const { id, groupId } = JSON.parse(window.localStorage.getItem("users"));

      const response = await Onboarding(CurrentUserId, id, groupId);

      // Progress is the share of tasks the user has ticked, matching the ring on
      // /Onboarding. A title that carries subtitles is only a heading there, so
      // it is not counted as a task of its own.
      const data = response.data.data || [];
      const subs = response.data.GetQuestion1 || [];
      const titleIdsWithSubs = new Set(subs.map((row) => Number(row.title_id)));
      const titleTasks = data.filter(
        (row) => !titleIdsWithSubs.has(Number(row.id)) && row.Links
      );
      const taskRows = [...titleTasks, ...subs];
      const doneRows = taskRows.filter((row) => row.conditions === "true");

      const progress = taskRows.length
        ? (doneRows.length / taskRows.length) * 100
        : 0;

      setOnboardingProgress(progress);
    } catch (error) {
      console.error("Failed to get onboarding progress:", error);
    }
  };

  useEffect(() => {
    // getData();
    userInfoData();
    getOnboardingProgress();
  }, [flag]);

  // Two states below 100%: still a long way off (error tone) and nearly there
  // (light green). Only a fully finished checklist gets the solid green below.
  const getOnboardingButtonColor = () => {
    if (onboardingProgress < 81) {
      return {
        background: "#FFCDD2", // Light Red
        hover: "#EF9A9A",
        text: "#B71C1C",
      };
    }

    if (onboardingProgress < 100) {
      return {
        background: "#C8E6C9", // Light Green
        hover: "#A5D6A7",
        text: "#1B5E20",
      };
    }

    return {
      background: theme.palette.secondary.main,
      hover: theme.palette.secondary.dark,
      text: theme.palette.secondary.light,
    };
  };

  const onboardingButtonColor = getOnboardingButtonColor();
  const isOnboardingIncomplete = onboardingProgress < 100;

  const fullname = fname + Space + lname;

  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/profile/personal");
  };

  const handleNavigateQIC = () => {
    navigate("/qic/dashboard2025?year=2026");
  };

  // Research Reports both in the header strip and the small-screen icon button
  // go through this: the SSO token is minted server-side for the signed-in user
  // and the returned URL carries it to the research portal.
  const handleResearchReportClick = async () => {
    try {
      const data = await researchReportSsoGenerate();

      if (data?.valid && data.redirectUrl) {
        window.open(data.redirectUrl, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Research report SSO failed:", error);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: 45,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        {layout === LAYOUT_CONST.VERTICAL_LAYOUT ||
        (layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && matchDownMd) ? (
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: "hidden",
              transition: "all .2s ease-in-out",
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.secondary.light,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.secondary.main
                  : theme.palette.secondary.dark,
              "&:hover": {
                background:
                  theme.palette.mode === "dark"
                    ? theme.palette.secondary.main
                    : theme.palette.secondary.dark,
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.secondary.light
                    : theme.palette.secondary.light,
              },
            }}
            onClick={() => dispatch(openDrawer(!drawerOpen))}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="20px" />
          </Avatar>
        ) : null}
      </Box>

      <Box
        component="span"
        sx={{
          display: { xs: "none", md: "block" },
          flexGrow: 1,
          // The wordmark is the row's only elastic item. It absorbs the slack
          // when there is any, and truncates here when there is not, so a narrow
          // viewport clips the tail of the strapline rather than pushing the
          // profile avatar off the right edge.
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        {/* Design's `.brand`: 20px/700 with a 17px/400 suffix. The strapline is
            ~170px of that and only fits once the whole row fits (lg), so below
            that the header reads "Dhruva". */}
        <Typography
          component="span"
          variant="h2"
          sx={{
            display: "block",
            fontSize: "20px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {" "}
          Dhruva{" "}
          <Box
            component="span"
            sx={{
              display: { xs: "none", lg: "inline" },
              fontSize: "17px",
              fontWeight: 400,
            }}
          >
            — The Samrat Command Centre
          </Box>
        </Typography>
      </Box>

      {/* Design's `.nav-pill`: one bordered strip holding the "Getting Started"
          label, the icon buttons and the solid "Research Reports" chip. The
          existing grey→blue border pulse is kept, but now reads from the theme
          instead of the hardcoded #c9c9c9 / #0767e6. No flex `gap` here: the
          three icon buttons already carry their own ml/mr, so a gap would
          double-count the design's 9px into 17-25px. */}
      {/* Getting Started + Research Reports */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "2px solid",
          borderColor: theme.palette.divider,
          padding: { xs: "6px 8px", sm: "6px 11px" },
          borderRadius: "12px",
          margin: "0px 7px 0px 5px",
          position: "relative",
          animation: "borderAnimation 2s infinite",
          "@keyframes borderAnimation": {
            "0%": {
              borderColor: theme.palette.divider,
            },
            "50%": {
              borderColor: theme.palette.secondary.main,
            },
            "100%": {
              borderColor: theme.palette.divider,
            },
          },
        }}
      >
        {/* Getting Started Button — pulses while the checklist is incomplete so
            it keeps pulling the user back to it. */}
        <Tooltip
          title={
            isOnboardingIncomplete
              ? `Onboarding ${Math.round(onboardingProgress)}% complete`
              : "Onboarding complete"
          }
        >
          <Button
            onClick={() => navigate("/Onboarding")}
            sx={{
              bgcolor: onboardingButtonColor.background,
              color: onboardingButtonColor.text,
              borderRadius: "7px",
              px: 1.5,
              py: 0.875,
              minWidth: 0,
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "none",
              whiteSpace: "nowrap",
              mr: 1,
              "&:hover": {
                bgcolor: onboardingButtonColor.hover,
              },
              ...(isOnboardingIncomplete && {
                animation: "onboardingBlink 1.5s ease-in-out infinite",
                "@keyframes onboardingBlink": {
                  "0%, 100%": { opacity: 1, transform: "scale(1)" },
                  "50%": { opacity: 0.65, transform: "scale(0.97)" },
                },
                "@media (prefers-reduced-motion: reduce)": {
                  animation: "none",
                },
              }),
            }}
          >
            Getting Started
          </Button>
        </Tooltip>

        {/* Research Reports */}
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          <Button
            onClick={handleResearchReportClick}
            sx={{
              bgcolor: "secondary.main",
              color: theme.palette.secondary.light,
              borderRadius: "7px",
              px: 1.5,
              py: 0.875,
              minWidth: 0,
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "none",
              whiteSpace: "nowrap",
              "&:hover": {
                bgcolor: "secondary.dark",
              },
            }}
          >
            Research Reports
          </Button>
        </Box>

        <Tooltip title="Research Reports">
          <IconButton
            onClick={handleResearchReportClick}
            aria-label="Research Reports"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              display: { xs: "inline-flex", sm: "none" },
              transition: "all .2s ease-in-out",
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.secondary.light,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.warning.dark
                  : theme.palette.secondary.dark,
              "&:hover": {
                background:
                  theme.palette.mode === "dark"
                    ? theme.palette.warning.dark
                    : theme.palette.secondary.dark,
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[800]
                    : theme.palette.secondary.light,
              },
            }}
          >
            <AssessmentOutlinedIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        component="span"
        sx={{
          display: { xs: "none", md: "flex" },
          padding: "10px",
          borderRadius: "10px",
          margin: "0px 7px 0px 5px",
          position: "relative",
        }}
      >
        <CalculatedIndex />
      </Box>
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          marginRight: "7px",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        {/* Design's `.me`: 15px/600, no wrap. */}
        <Typography
          variant="h3"
          sx={{
            fontSize: "15px",
            fontWeight: 600,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {fullname}
        </Typography>
      </Box>
      <Box
        sx={{
          display: { xs: "block", sm: "block" },
          marginRight: { xs: "13px", sm: "7px" },
        }}
      >
        <ProfileSection fullname={fullname} email={email} />
      </Box>
    </>
  );
};

export default Header;
